var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-tag",
    class: ( _obj = {
      "cm-tag--is-focused": _vm.isFocused
    }, _obj[("cm-tag--" + _vm.theme)] = _vm.theme, _obj )
  }, [_vm._t("default"), _vm._v("\n  " + _vm._s(_vm.label || _vm.value) + "\n  "), _c('button', {
    staticClass: "cm-tag__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('delete', _vm.value)
      },
      "focus": function($event) {
        _vm.isFocused = true
      },
      "blur": function($event) {
        _vm.isFocused = false
      }
    }
  }, [_vm._v("close")])], 2)
  var _obj;
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f02b9c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/tag.vue
// module id = null
// module chunks = 